import { render, staticRenderFns } from "./DemandItem.vue?vue&type=template&id=3469dfca&scoped=true&"
import script from "./DemandItem.vue?vue&type=script&lang=js&"
export * from "./DemandItem.vue?vue&type=script&lang=js&"
import style0 from "./DemandItem.vue?vue&type=style&index=0&id=3469dfca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3469dfca",
  null
  
)

export default component.exports